









import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { formatFileSize } from '@/utils/helper';
import { IOssDownloadList } from '@/store/home/stats/types';
import * as echarts from 'echarts';
import chartOption from './options';

const Stats = namespace('home/stats');

@Component
export default class OssDownloadChart extends Vue {
  @Stats.State('ossDownloadList') public list!: IOssDownloadList;

  @Prop() public cols!: number; // 布局列宽
  @Prop() public title!: string;

  @Ref('chart') public chartDom!: HTMLDivElement;

  public chart!: echarts.ECharts;

  public mounted() {
    this.chart = echarts.init(this.chartDom);
    this.chart.setOption(chartOption);  // 初始化配置(没有数据)
    window.addEventListener('resize', this.watchCols.bind(this));
  }

  public beforeDestroy() {
    window.removeEventListener('resize', this.watchCols);
  }

  // 列宽变更时，调整图表大小
  @Watch('cols')
  public watchCols() {
    this.$nextTick(() => this.chart.resize());
  }

  // 初始化图表数据
  @Watch('list.data', { immediate: true })
  public dataChange(data: IOssDownloadList['data']) {
    const xAxisData = data.map((item) => item.userName);
    const totalSizeList = data.map((item) => ({ ...item, value: item.totalSize / (1024 * 1024 * 1024) }));
    const totalList = data.map((item) => ({ ...item, value: item.totalCount }));
    const hasData = !!data.length;

    this.$nextTick(() => {
      this.chart.setOption({
        tooltip: { formatter: this.tooltipFormat },
        xAxis: [{ data: xAxisData }],
        series: [{ data: totalSizeList }, { data: totalList }],
        graphic: { invisible: hasData },
        nameTextStyle: { color: hasData ? '' : 'transparent' },
      });
    });
  }

  // tooltip 内容格式化
  public tooltipFormat(params: any) {
    const record = params[0]!.data;
    const totalSize = formatFileSize(record.totalSize);
    return `
      <div>用户名称: ${record.userName}</div>
      <div>组织名称：${record.orgName}</div>
      <div>总体积：${totalSize}</div>
      <div>总次数：${record.totalCount}</div>
    `;
  }
}
